import React from 'react';
import './index.less.js';

var Description = function Description(props) {
  var title = props.title;
  if (!title) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "ti-form-item-desc"
  }, title);
};

export { Description as default };
